import { NewGameModalActionType } from '../../types/newGameModalType'

export const setNewGameModal = () => {
    return {type: NewGameModalActionType.CHANGE_VALUE_NEW_GAME_MODAL}
}